import { CommonModule } from '@angular/common';
import { Component, OnInit, Input } from '@angular/core';

@Component({
	standalone: true,
	imports: [CommonModule],
	selector: 'cpi-dot-bounce-loading-effect',
	templateUrl: './dot-bounce-loading-effect.component.html',
	styleUrls: ['./dot-bounce-loading-effect.component.scss'],
})
export class DotBounceLoadingEffectComponent implements OnInit {
	@Input()
	color = '#999';

	@Input()
	size = 5;

	@Input()
	type: 'bounce' | 'appear' = 'appear';

	constructor() {}

	ngOnInit(): void {}
}
